import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    boxShadow: "0 0 10px 0 rgba(18, 38, 63, 0.08)",
    borderRadius: 10,
    marginBottom: (classProps) =>
      classProps.marginBottom ? classProps.marginBottom : 0,
  },
}));

const CustomPaper = ({ children, classProps, design, onClick = () => {}, ...props }) => {
  const classes = useStyles(classProps);
  return <Paper className={`${classes.paper} ${design}`} onClick={onClick} {...props}>{children}</Paper>;
};

export default CustomPaper;
